
const MwSwitch = ({onChangeSwitch,custKey,isActive,setIsActive}) => {

    const onClickSwitch = () => {
        const nextValue = !isActive;
        setIsActive(nextValue);
        if (onChangeSwitch) {
            onChangeSwitch({key:custKey , value:nextValue});
        }
    }

    return (
        <div 
            onClick={() => onClickSwitch()} 
            className={`relative flex h-6 w-11 cursor-pointer items-center rounded-full transition-colors ${isActive ? 'bg-emerald-500' : 'bg-slate-300'}`}>
            <div className={`h-5 w-5 rounded-full bg-white shadow transition-transform ${isActive ? 'translate-x-5' : 'translate-x-1'}`}></div>
        </div>
    )
}

export default MwSwitch
